import * as actionTypes from "./actionTypes";
import * as apiCall from "../services/api";
import { API_BASE_URL } from "../config/apiConfig";


export const getReferralRecordSuccess = (data) => {
  return {
    type: actionTypes.GET_REFERRAL_RECORD,
    payload: {
      referralRecord: data.Data,
    },
  };
};

export const getReferralRecord = (data) => async (dispatch) => {
  return await apiCall
    .axiosPost(`${API_BASE_URL}/ReferralRecord`, data)
    .then((response) => {
      if (response) {
        dispatch(getReferralRecordSuccess(response.data));
      }
    })
    .catch((error) => {
      console.log('Error: ', error);
    });
};
